import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives, createElementVNode as _createElementVNode, Teleport as _Teleport, withModifiers as _withModifiers, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { getCurrentInstance, ref } from 'vue';
import { ComponentInternalInstance } from '@vue/runtime-core';
import { useAppStore } from '@/store/modules/app';


export default /*#__PURE__*/_defineComponent({
  __name: 'BasePopup',
  props: {
    start: { type: Boolean },
    showCloseIcons: { type: Boolean },
    withPadding: { type: Boolean },
    disabled: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;
const showPopup = ref(false);
const popupBtn = ref<HTMLElement | undefined>();
const popupContent = ref<HTMLElement | undefined>();
const instance: ComponentInternalInstance | null = getCurrentInstance();
const uuid = ref(instance?.uid);

const closePopup = () => {
  showPopup.value = false;
  if (useAppStore().window <= 600) {
    document.body.classList.remove('overflow-hidden');
  }
};

const openSheet = (e: Event) => {
  if (!props.disabled) {
    e.stopPropagation();
    showPopup.value = true;
    if (useAppStore().window > 600) {
      setTimeout(() => {
        let popup = document.querySelector<HTMLElement>(`.popup${uuid.value}`)!;

        if (popupBtn.value && popupContent.value) {
          let styleLeft: number;

          if (props.start) {
            styleLeft = popupBtn.value.getBoundingClientRect().x;
          } else {
            styleLeft =
              popupBtn.value.getBoundingClientRect().x -
              popupContent.value.getBoundingClientRect().width +
              popupBtn.value.getBoundingClientRect().width;
          }
          popup.style.left = styleLeft < 0 ? '10px' : styleLeft + 'px';

          popup.style.top =
            popupBtn.value.getBoundingClientRect().y +
            popupBtn.value.getBoundingClientRect().height +
            document.documentElement.scrollTop +
            10 +
            'px';
        }
      }, 10);
    } else {
      document.body.classList.add('overflow-hidden');
    }
  }
};

return (_ctx: any,_cache: any) => {
  const _component_base_icon = _resolveComponent("base-icon")!
  const _component_base_card = _resolveComponent("base-card")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, {
      disabled: _ctx.disabled,
      to: "#portal"
    }, [
      _createElementVNode("div", null, [
        _createElementVNode("div", {
          id: "popup",
          ref_key: "popupContent",
          ref: popupContent,
          class: _normalizeClass([[{ showPopup: showPopup.value }, `popup${uuid.value}`], "popup"])
        }, [
          _withDirectives((_openBlock(), _createBlock(_component_base_card, {
            class: _normalizeClass([{ 'with-padding': _ctx.withPadding }, "popup__content"])
          }, {
            default: _withCtx(() => [
              (_ctx.showCloseIcons)
                ? (_openBlock(), _createBlock(_component_base_icon, {
                    key: 0,
                    class: "popup__content-close-icon",
                    clickable: "",
                    "font-size": "24",
                    name: "close",
                    onClick: closePopup
                  }))
                : _createCommentVNode("", true),
              _renderSlot(_ctx.$slots, "content")
            ]),
            _: 3
          }, 8, ["class"])), [
            [_directive_click_outside, () => closePopup()]
          ])
        ], 2)
      ])
    ], 8, ["disabled"])),
    _createElementVNode("div", {
      ref_key: "popupBtn",
      ref: popupBtn,
      onClick: _withModifiers(openSheet, ["stop"])
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 512)
  ], 64))
}
}

})